module.exports = __webpack_public_path__ + "img/login_slide_06.2c9c036c.webp";